export default {
  OPEN: "OPEN",
  ISSUERAISED: "ISSUERAISED",
  FALSEPOSITIVE: "FALSEPOSITIVE",
  QUERY: "QUERY",
  RESOLVED: "RESOLVED",
};
